// extracted by mini-css-extract-plugin
export var content = "Tooltip-module--content--099e9";
export var tooltip = "Tooltip-module--tooltip--eed17";